<template>
	<core-layout-content large>
		<core-layout-headline-and-actions>
			<template slot="headline">{{ $t("create_achievement") }}</template>
		</core-layout-headline-and-actions>

		<!-- Language selector -->
		<div class="xs-4 mb4" v-if="$store.state.settings.allowedLocales">
			<div class="pr2 xs-12 fs3 lh125 fw7 pb1">{{ $t("language") }}</div>
			<core-select-locale
				class="xs-12"
				size="xsmall"
				v-model="selectedLocale"
			/>
		</div>

		<!-- Body -->
		<j-card class="xs-12 bg5 r2 p4">
			<!-- Type -->
			<div class="fw7 fs3 pb2">{{ $t("type") }}</div>
			<j-base-input-text size="small" v-model="form.type" />

			<!-- Name -->
			<div class="fw7 fs3 pb2 mt4">{{ $t("name") }}</div>
			<j-base-input-text size="small" v-model="form.name" />

			<!-- Description -->
			<div class="fw7 fs3 pb2 mt4">{{ $t("description") }}</div>
			<j-base-input-long-text size="small" v-model="form.description" />

			<!-- Logic -->
			<div class="fw7 fs3 pb2 mt4">{{ $t("achievement_logic") }}</div>
			<achievement-logic v-model="form.logic" />

			<!-- Buttons -->
			<div class="mt8">
				<j-button
					class="mr4"
					size="small"
					:isLoading="isLoading"
					@click="handleSubmit"
				>
					{{ $t("create_achievement") }}
				</j-button>
				<j-button
					size="small"
					type="secondary"
					@click="$router.push({ name: 'AchievementsList' })"
				>
					{{ $t("cancel") }}
				</j-button>
			</div>
		</j-card>
	</core-layout-content>
</template>

<script>
import JCard from "@/components/JCard/"
import JButton from "@/components/JButton/"
import JBaseInputText from "@/components/JBaseInputText/"
import JBaseInputLongText from "@/components/JBaseInputLongText/"
import CoreLayoutContent from "@/modules/core/components/CoreLayoutContent.vue"
import CoreLayoutHeadlineAndActions from "@/modules/core/components/CoreLayoutHeadlineAndActions.vue"
import AchievementLogic from "../components/AchievementLogic"
import CoreSelectLocale from "@/modules/core/components/CoreSelectLocale"

import { i18n } from "@/locales/setup.js"
import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default {
	components: {
		JCard,
		JButton,
		JBaseInputText,
		JBaseInputLongText,
		CoreLayoutContent,
		CoreLayoutHeadlineAndActions,
		AchievementLogic,
		CoreSelectLocale
	},

	data() {
		return {
			isLoading: false,
			selectedLocale: i18n.locale,
			form: {
				type: null,
				name: null,
				description: null,
				logic: null
			}
		}
	},

	methods: {
		async handleSubmit() {
			this.isLoading = true
			/*
			 * Create achievement
			 */
			const query = gql`
				mutation createAchievementType($input: createAchievementTypeInput!) {
					createAchievementType(input: $input) {
						createdStatus {
							id
						}
						errors
						status
					}
				}
			`

			const variables = {
				input: {
					type: this.form?.type,
					logic: this?.form?.logic
				}
			}

			const res = await api({ query, variables })

			const createdId = res?.data?.createAchievementType?.createdStatus?.id
			if (
				res?.data?.createAchievementType?.status !== "success" ||
				!createdId
			) {
				this.$store.dispatch(
					"showError",
					res?.data?.createAchievementType?.errors[0] ||
						this.$t("errors.general")
				)
				this.isLoading = false
				return
			}

			/*
			 * Upsert l10n
			 */

			// Name
			const l10nquery = gql`
				mutation upsertL10n($l10n: upsertL10nInput) {
					upsertL10n(l10n: $l10n) {
						status
						errors
					}
				}
			`
			if (this?.form?.name) {
				const nameRes = await api({
					query: l10nquery,
					variables: {
						l10n: {
							locale: this.selectedLocale,
							key: `achievements-${createdId}-name`,
							value: this?.form?.name
						}
					}
				})
				if (nameRes?.data?.upsertL10n?.status !== "success") {
					this.$store.dispatch(
						"showError",
						nameRes?.data?.upsertL10n?.errors[0] || this.$t("errors.general")
					)
					this.isLoading = false
					return
				}
			}
			// Description
			if (this?.form?.description) {
				const descRes = await api({
					query: l10nquery,
					variables: {
						l10n: {
							locale: this.selectedLocale,
							key: `achievements-${createdId}-description`,
							value: this?.form?.description
						}
					}
				})
				if (descRes?.data?.upsertL10n?.status !== "success") {
					this.$store.dispatch(
						"showError",
						descRes?.data?.upsertL10n?.errors[0] || this.$t("errors.general")
					)
					this.isLoading = false
					return
				}
			}

			// Succes - redirect
			this.isLoading = false
			this.$router.push({
				name: "AchievementsList"
			})
		}
	}
}
</script>
